export const isRouteDisabled = (user) => !user.selectedCompany && user.demo;

export const hasShowSubRoutes = (user, subRoutes) => (
  subRoutes.filter((route) => route.show).length > 0
);

export const userHasRoutePermission = (user, ...perms) => (
  [...perms].some((perm) => user?.permissions?.includes(perm))
);
